import moment from "moment";

import {
  CustomerAcknowledgementInputDto,
  CustomerDto,
  CustomerReferenceDto,
  CustomerVerificationMethod,
} from "@/core/api/generated/v1";

/** Any entity DTO type according to @type EntityFormType */
export type CustomerDtoAny = CustomerDto | CustomerReferenceDto;

/** All entity DTO types according to @type EntityFormType */
export type CustomerDtoAll = CustomerDto & CustomerReferenceDto;

export class CustomerMapper {
  public static prepareCustomerAcknowledgementInputDtoForApi(
    value: CustomerAcknowledgementInputDto,
  ) {
    return {
      ...value,
      method: value.method || CustomerVerificationMethod.ManualSignature,
      privacyPolicyAcceptedAt: value.privacyPolicyAcceptedAt
        ? moment(value.privacyPolicyAcceptedAt).utc().format()
        : value.capturedAt || moment().utc().format(),
      damageBookViewedAt: value.damageBookViewedAt
        ? moment(value.damageBookViewedAt).utc().format()
        : value.capturedAt || moment().utc().format(),
      signedAt: value.signedAt ? moment(value.signedAt).utc().format() : null,
      capturedAt: value.capturedAt
        ? moment(value.capturedAt).utc().format()
        : moment().utc().format(),
    } satisfies typeof value;
  }
}
